import React, { useEffect, useMemo } from 'react';
import { default as classNames, default as classnames } from 'classnames';
import { useIsLivePage, useLiveInfo } from 'features/sport/hooks';

import { isTruthy } from 'utility/functions';
import { removeAvvenimentoContentTabList } from 'features/sport/sportSlice';
import styles from './ScommesseTableDateTime.module.scss';
import { useAmbienteContext } from 'context/Ambiente';
import { useAppDispatch } from 'lib/centralStore';
import { useTranslation } from 'hooks/useLingUI';

export type ScommesseTableDateTimeProps = {
  ora: string;
  data?: string;
  className?: string;
  currentSlug?: string;
  avvenimentoKey?: string;
  time?: {
    minutes: number;
    seconds: number;
    elapsedTime: number | undefined;
  };
};

export const ScommesseTableDateTime = ({ data, ora, className, time, avvenimentoKey }: ScommesseTableDateTimeProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLivePage = useIsLivePage();
  const { pathScommessa } = useAmbienteContext();

  const { status, statusTrKey, matchTime } = useLiveInfo(avvenimentoKey) ?? {};
  const aSeguireKey = 'a-seguire';

  useEffect(() => {
    if (
      pathScommessa?.includes('templateProssimiEventi') &&
      time &&
      time.elapsedTime &&
      time.elapsedTime <= 0 &&
      time.minutes <= 0 &&
      time.seconds <= 0 &&
      avvenimentoKey
    ) {
      dispatch(removeAvvenimentoContentTabList(avvenimentoKey));
    }
  }, [time, pathScommessa, avvenimentoKey, dispatch]);

  const { isLive } = useMemo(() => {
    let isLive = false;
    if (isLivePage && !pathScommessa?.includes('templateProssimiEventi')) {
      isLive = true;
    } else if (isTruthy(`${matchTime ?? ''}${status ?? ''}`.length)) {
      isLive = true;
    }
    return { isLive };
  }, [isLivePage, matchTime, status, pathScommessa]);

  return (
    <ul className={classNames(styles.container, className)}>
      {!!time && time.elapsedTime! > 0 && time.minutes <= 3 ? (
        <p className={`${styles.text} ${className ? className : ''}`}>{t(aSeguireKey)}</p>
      ) : isLive ? (
        <React.Fragment key={`${status}-${matchTime}`}>
          <li className={classnames(styles.listItem, styles.highlighted)}>live</li>
          {status && <li className={styles.listItem}>{t(statusTrKey, status)}</li>}
          {matchTime && <li className={classnames(styles.listItem, styles.minutes)}>{matchTime}</li>}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {data && <li className={classnames(styles.listItem, styles.date)}>{data}</li>}
          {ora && <li className={styles.listItem}>{ora}</li>}
        </React.Fragment>
      )}
    </ul>
  );
};
